export default function clip({ width, height, aspectRatio }) {
  return Math.max((height - (width / aspectRatio).toFixed(0)), 0) / 2
}



// WEBPACK FOOTER //
// ./src/helpers/fovPreview/clip.js